module.exports = __webpack_public_path__ + "hdslide_logo_new.21841cc4.jpg";